import SelfReadingTypeEnumDTO from 'features/requirements/dtos/SelfReadingTypeEnumDTO';
import FormGroup from 'features/shared/forms/components/FormGroup';
import { Nullable } from 'features/shared/types/nullable';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  name: string;
  types: SelfReadingTypeEnumDTO[];
  value?: Nullable<string>;
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  editable: boolean;
  errors?: Record<string, string>;
}

const SelfReadingType = ({ name, types, value, onChange, editable, errors }: Props) => {
  // translations
  const tLabels = useTranslation("requirements\\requirements").t;

  if (editable) {
    return (
      <FormGroup labelText={tLabels("selfReadingType.selfReadingReason")} inputId={name} validationError={errors ? errors[name] : undefined}>
        <select id={name} className="custom-select" onChange={onChange} value={value || ""}>
          <option value="" disabled className="d-none">{tLabels("selfReadingType.setSelfReadingReason")}</option>
          {types.map((item, index) => 
            <option value={item.selfReadingTypeId} key={index}>{item.name}</option>
          )}
        </select>
      </FormGroup>
    )   
  } else {
    return null;
  }
}

export default SelfReadingType;